import { makeStyles } from '@material-ui/core/styles';

export const mapUseStyles = makeStyles(theme => ({
  DrawingApprovedAreasMap: {
    height: '100%',
    position: 'relative',
    width: '100%',
    '&__fileInput': {
      padding: 10,
      marginBottom: 20,
      display: 'none',
      '&__span': {
        paddingLeft: 20,
      },
    },
    '&__icons-wrapper': {
      display: 'flex',
      alignItems: 'center',
      backgroundColor: theme.palette.blackAlfa,
      borderRadius: 15,
      flexDirection: 'column',
      justifyContent: 'space-evenly',
      position: 'absolute',
      padding: '5px 0',
      right: 10,
      top: '50%',
      transform: 'translateY(-50%)',
      width: 30,
      zIndex: 1003,
    },
    '&__map-icon': {
      cursor: 'pointer',
      padding: '5px 0',
      right: 10,
      color: theme.palette.white,
      borderRadius: '50%',
      backgroundColor: 'transparent',
      transition: 'color 0.25s, background-color 0.25s, box-shadow 0.25s',
      '&:hover': {
        color: theme.palette.white,
        backgroundColor: theme.palette.green,
        boxShadow: `0 0 5px ${theme.palette.white}`,
      },
      '&:visited': {
        color: theme.palette.green,
        backgroundColor: 'transparent',
      },
      '&--active': {
        color: theme.palette.green,
        backgroundColor: 'transparent',
      },
      '&--select-file': {
        fontSize: 22,
      },
    },
    '&__object-wrapper': {
      display: 'flex',
      alignItems: 'center',
      backgroundColor: theme.palette.blackAlfa,
      borderRadius: 15,
      color: theme.palette.green,
      flexDirection: 'column',
      justifyContent: 'space-evenly',
      position: 'absolute',
      right: 10,
      bottom: 5,
      width: 30,
      zIndex: 1003,
    },
    '&__map-wrapper': {
      '&__inner': {
        height: '100%',
        width: '100%',
        '& div': {
          borderRadius: 5,
        },
      },
    },
    '&__switch-wrapper': {
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column',
      justifyContent: 'space-evenly',
      backgroundColor: 'rgba(0, 0, 0, 0)',
      color: theme.palette.primary.main,
      opacity: 0.8,
      position: 'absolute',
      left: '88%',
      right: 0,
      top: '95%',
      zIndex: 1003,
      borderRadius: '10px',
      height: '30px',
      width: '4%',
      margin: '0px auto 0px auto',
      transition: 'height 1s, width 2s, top 1s',
      textAlign: 'center',
      overflow: 'hidden',
      '&:hover ': {
        width: '124px',
        height: '80px',
        backgroundColor: theme.palette.backgroundColor,
        top: '90%',
      },
      '&:hover  &__switch': {
        transition: 'margin-top 1s',
        marginTop: 0,
      },
      '&__switch': {
        transition: 'margin-top 1s',
        marginTop: 38,
      },
    },
    '&__switch-buttons': {
      display: 'flex',
      flexDirection: 'row',
      // width: 'auto',
      zIndex: 1003,
    },

    '&__slider-wrapper': {
      position: 'absolute',
      top: 80,
      zIndex: 1004,
      '&--width': {
        bottom: 20,
        left: 60,
        position: 'absolute',
        width: 300,
        zIndex: 1004,
      },
    },
  },
  ChoiceButton: {
    '&__root': {
      minWidth: '34px',
      maxWidth: '38px',
      minHeight: '32px',
      padding: '3px 3px',
      fontSize: 6,
      margin: '1px 3px',
      borderRadius: '1px',
    },
  },
}));
